export default __webpack_public_path__ + "static/media/GPA25024D_homebanner_art.9bca1e23.jpg";